<template>
  <div v-if="!patient" class="no-patient">
    No patient selected
  </div>
  <div v-else-if="previousSessionsData.length && !showPreviousSessionDetails" class="tabmenudemo-content">
    <div v-for="patient in previousSessionsData" :key="patient.mrn" class="container-div"
      @click="setPreviousSessionDetails(patient)">
      <div>
        <span class="date-span">{{ formatDate(patient.date) }}</span>
      </div>
      <div>
        <span class="tumor-board-span">{{ `${patient.tb_name} Tumor Board Meeting` }}</span>
      </div>
    </div>
  </div>
  <div v-else-if="!previousSessionsData.length && !showPreviousSessionDetails && !isLoading">
    <p class="no-records-class">No Previous sessions found</p>
  </div>
  <div v-if="showPreviousSessionDetails">
    <RecordedPreviousSessionDetails :previousSessionDetails="selectedRecordedPreviousSessionDetails" />
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { computed, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { formatDate } from '@/utils/utils.js'
import RecordedPreviousSessionDetails from './RecordedPreviousSessionDetails.vue'

const store = useStore()
const previousSessionsData = ref([])
const selectedRecordedPreviousSessionDetails = ref({})
const isLoading = ref(true)
const showPreviousSessionDetails = ref(false)
const patient = computed(() => store.getters.session.patient)
const tumorBoardSessionsData = computed(() => store.getters.session.tumorBoardSessionsData)
const previousSessionsList = computed(() => store.state.session.previousSessionsData)

watch([patient, tumorBoardSessionsData], async ([newPatient, newTumorBoardSessionsData]) => {
  if (!newPatient || !newTumorBoardSessionsData) { return }
  const previousSessions = newTumorBoardSessionsData.Past
  previousSessionsData.value = previousSessions?.map(item => ({ ...item, mrn: patient.value.id })) || []
  store.dispatch('setPreviousSessionsList', { previousSessionsData, publish: true })
  isLoading.value = false
  showPreviousSessionDetails.value = false
})

const setPreviousSessionDetails = (previousSessionDetails) => {
  selectedRecordedPreviousSessionDetails.value = previousSessionDetails
  store.dispatch('setSelectedRecordedPreviousSession', { selectedRecordedPreviousSessionDetails, publish: true })
  showPreviousSessionDetails.value = true
}

onMounted(() => {
  previousSessionsData.value = previousSessionsList.value || []
})

</script>

<style scoped>
.tabmenudemo-content {
  text-align: initial;
  cursor: pointer;
}

.date-span {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: var(--Grey500);
}

.tumor-board-span {
  font-size: 14px;
  font-weight: 400;
  line-height: 16.41px;
  letter-spacing: -0.32px;
  color: var(--Grey800);
}

.notes-span {
  font-size: 12px;
  font-weight: 300;
  line-height: 16.41px;
  letter-spacing: -0.32px;
  color: var(--Grey900);
}

.container-div {
  margin-bottom: 10%;
}

.no-patient {
  color: var(--Grey600);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 200px;
}

.no-records-class {
  color: var(--Black);
  font-size: 1.125rem;
  font-weight: 500;
}
</style>
